import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useContext } from "react";

const PRODUCT_FLAG_KEYS = [
  FeatureFlagKey.MERCHANT_RECLAIM_ONBOARDING_ASYNC,
  FeatureFlagKey.SHOPPER_AGENT,
] as const;

function getTeamFeatureFlags(
  team: unknown,
): Partial<Record<FeatureFlagKey, boolean>> | undefined {
  return (team as { featureFlags?: unknown } | null | undefined)
    ?.featureFlags as Partial<Record<FeatureFlagKey, boolean>> | undefined;
}

/**
 * Returns true when at least one setup-guide product is enabled for the
 * current team. Returns false until team data has loaded so the widget never
 * renders with stale or missing flag state.
 */
export function useAnySetupGuideProductEnabled(): boolean {
  const team = useContext(TeamContext);
  if (!team) {
    return false;
  }
  const setupGuideFlags = getTeamFeatureFlags(team);
  return PRODUCT_FLAG_KEYS.some(
    (flagKey) => setupGuideFlags?.[flagKey] === true,
  );
}

export function isShopperAgentPhoneProvisioningEnabled(team: unknown): boolean {
  const flags = getTeamFeatureFlags(team);
  return (
    flags?.[FeatureFlagKey.MERCHANT_SHOPPER_AGENT_ONBOARDING_ASYNC] === true
  );
}

export function isMerchantWalkthroughEnabled(team: unknown): boolean {
  const flags = getTeamFeatureFlags(team);
  return flags?.[FeatureFlagKey.MERCHANT_WALKTHROUGH] === true;
}

export function useReclaimAsyncOnboardingEnabled(): boolean {
  const team = useContext(TeamContext);
  if (!team) {
    return false;
  }
  return (
    getTeamFeatureFlags(team)?.[
      FeatureFlagKey.MERCHANT_RECLAIM_ONBOARDING_ASYNC
    ] === true
  );
}
